import {
  CategoryDistributionChart,
  ProductsExports,
  ReportProductsFilter,
  TopProductsChart
} from '@crm/features/reports/components'

import { Col, Flex, Row } from 'antd'

export const ReportProducts = () => {
  return (
    <Flex vertical gap={16}>
      <ReportProductsFilter />

      <Row gutter={20}>
        <Col span={12}>
          <TopProductsChart />
        </Col>

        <Col span={12}>
          <CategoryDistributionChart />
        </Col>
      </Row>

      <ProductsExports />
    </Flex>
  )
}
